export enum recordingsSelectOptionsEnum {
  all = 0,
  seen = 1,
  unseen = 2,
  starred = 3,
  unstarred = 4,
  all_on_page = 5,
}
